import { withInstall } from "../utils/index.mjs";
import _List from "./List.mjs";
const List = withInstall(_List);
var stdin_default = List;
import { listProps } from "./List.mjs";
export {
  List,
  stdin_default as default,
  listProps
};
